<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-9 col-sm float-left">
            <h1 class="page-title">Affiliate Leads</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-3 mt-3">
                    <div class="col-sm-3 mt-1"><input class="form-control" [(ngModel)]="search" type="text"
                            placeholder="Search" /></div>

                    <div class="col-sm-2 mt-1">
                        <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                            <input class="mySearchInput"
                            #treatmentSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'treatment')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="treatmentSearch">
                            <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                        </mat-select>
                    </div>
                   
                    <div class="col-sm-2 mt-1">
                        <mat-select placeholder="Select City" [(ngModel)]="city" (click)="setSearchValue('city')" multiple>
                            <input class="mySearchInput"
                            #citySearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'city')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="citySearch">
                                <mat-option>Select City</mat-option>
                                <mat-option [value]="city.city_id" *ngFor="let city of cities">{{city.name}}</mat-option>
                            </mat-select>
                    </div>

                    <div class="col-sm-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div>

                    <div class="col-sm-3 mt-1">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadLeads(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadLeads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button></div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th *ngIf="role=='1'|| (role=='3' && cm_access=='1')">Contact Number</th>
                            <th>City</th>
                            <th>Treatment</th>
                            <th>LEAD DATE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let leads of leadList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{leads.lead_name}}</td>
                            <td *ngIf="role=='1'|| (role=='3' && cm_access=='1')">{{leads.mobile}}</td>
                            <td>{{leads.city_name}}</td>
                            <td>{{leads.treatment_name}}</td>
                            <td>{{leads.created_at*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !leadList.length">
                            <td colspan="20"><i class="far fa-frown"></i> Leads not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>
</div>